import * as React from 'react';

interface NonPaymentReasonFormContextInfo {
  errors: Record<string, string>,
  setErrors: React.Dispatch<
  React.SetStateAction<Record<string, string>>
  >,
  hasFormErrors: boolean,
}

const NonPaymentReasonFormContext = React.createContext<
NonPaymentReasonFormContextInfo | null
>(null);

export const useNonPaymentReasonFormContext = () => React.useContext(NonPaymentReasonFormContext);

export const NonPaymentReasonFormContextProvider: React.FC = ({ children }) => {
  const [ errors, setErrors ] = React.useState<NonPaymentReasonFormContextInfo['errors']>({});

  const hasFormErrors = React.useMemo(() => Object.keys(errors).length > 0, [ errors ]);

  const value = React.useMemo(() => ({
    errors, setErrors, hasFormErrors,
  }), [ errors, setErrors, hasFormErrors ]);

  return (
    <NonPaymentReasonFormContext.Provider value={value}>
      {children}
    </NonPaymentReasonFormContext.Provider>
  );
};
